// eslint-disable-next-line prettier/prettier, arrow-parens
/* eslint-disable arrow-parens */
import { StatusCodes } from "http-status-codes";
import { request } from "../../api";
import { headers } from "../../../../config/config";
import { MESSAGE } from "../../../../constants/api/message";
import { AUTHORIZATION } from "../../../../constants/api/auth";
const { post } = request;
const { Authorization, Bearer } = AUTHORIZATION;

const initialRoute = "creation";

export const createEmployee = async (_payload) => {
	try {
		const payload = JSON.stringify(_payload);
		const endpoint = `${initialRoute}/create-employee`;
		const token = localStorage.getItem("@jwt");

		const response = await post(endpoint, payload, {
			...headers,
			[Authorization]: `${Bearer} ${token}`
		});

		if (response) {
			const {
				data: { message, result }
			} = response;

			if (message === MESSAGE.post.succ) {
				return result;
			}
		}

		throw new Error("Unexpected response format");
	} catch (error) {
		console.error("Error in createEmployee:", error);
		// ---- SAFETY CHECK ----
		const status = error?.response?.status;
		const message = error?.response?.data?.message;

		// No response = network error, CORS issue, timeout, etc.
		if (!status) {
			console.error("Network or unexpected error:", error);
			alert("A network error occurred. Please try again.");
			return;
		}

		if (status === StatusCodes.BAD_REQUEST) {
			switch (message) {
				case "Invalid Email!":
					alert("Invalid Email!");
					break;
				case "Email is already registered!":
					alert("Email is already registered!");
					break;
				case "SSN is already registered!":
					alert("SSN is already registered!");
					break;
				case "Unauthorized Role!":
					alert("Unauthorized Role!");
					break;
				case "Employee is already created!":
					alert("Employee is already created!");
					break;
				case "Hire Date and Employment Start Date must be same during Employee Creation!":
					alert("Hire Date and Employment Start Date must be same during Employee Creation!");
					break;
				case "Hire Date and Paycheck Start Date must be same during Employee Creation!":
					alert("Hire Date and Paycheck Start Date must be same during Employee Creation!");
					break;
				case MESSAGE.post.fail:
					alert("Failed to Create Employee!");
					break;
				default:
					alert("Other Errors of Status Code 400");
			}
			return;
		}

		// Other server errors (401, 403, 500, etc.)
		console.error("Server error:", error);
		alert("Unexpected server error.");
	}
};
